import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UtilsService } from 'src/app/common';
import { BaseSearchResultsComponent } from '../base-search-results/base-search-results.component';
import { SortEvent } from 'primeng/api';
import { TableModule } from 'primeng/table';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'gig-link-intersect-results',
  standalone: true,
  imports: [CommonModule, TableModule, TranslateModule],
  templateUrl: './link-intersect-results.component.html',
  styleUrls: ['./link-intersect-results.component.scss']
})
export class LinkIntersectResultsComponent extends BaseSearchResultsComponent implements OnInit {

  public selectedItem: any;

  @Input() cols: any[];
  @Input() numOfTargets: number;
  @Input() source: string = '';

  public customSortField: string = '';
  public customSortOrder: number = 1; // 1 for ascending, -1 for descending

  constructor(public utils: UtilsService) {
    super(utils);
   }

  ngOnInit(): void {
  }

  public customSort(event: SortEvent): void {
    this.utils.logger.info('LinkIntersectResultsComponent.customSort()');
    this.customSortField = event.field;
    this.customSortOrder = this.customSortOrder * -1; // Toggle between ascending and descending
    //adding a comment
    // event.data.sort((a, b) => {
    //   const keywordA = a?.domainIntersection[event.field]?.toLowerCase() ?? a?.keywordData?.keyword;
    //   const keywordB = b?.keyword?.toLowerCase() ?? b?.keywordData?.keyword;
    //   const comparison = keywordA?.toLowerCase().localeCompare(keywordB?.toLowerCase());
    //   return event.order === 1 ? comparison : -comparison;
    // });
  }

  public onSelectedBacklinkClicked(e: any): void {

  }

  public getIntersectKeys(item: any): string[] {
    return Object.keys(item);
  }

}
